import { cloneDeep, isEqual } from 'lodash';

import { Action } from '../../actions';
import { UPDATE_GRID_BANNER_PRICE, UPDATE_GRID_BANNER_PRICE_CELL } from '../../actions/banners-grid';
import { DELETE_BRAND_LIFT_STATUS, SET_BRAND_LIFT_REJECT_REASONS } from '../../actions/brandLift';
import {
    CHANGE_CAMPAIGN_AND_GROUP_SELECTOR_STATUS,
    CLOSE_CAMPAIGN_AND_GROUP_SELECTOR,
    OPEN_CAMPAIGN_AND_GROUP_SELECTOR,
    SELECT_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGN,
    SELECT_CAMPAIGN_AND_GROUP_SELECTOR_GROUP,
    SET_CAMPAIGN_AND_GROUP_SELECTOR_ENTITY_TYPE,
    UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA,
    UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA
} from '../../actions/campaignAndGroupSelector';
import { UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE } from '../../actions/campaigns-grid';
import {
    TOGGLE_FEED_FILTER_PRIORITY_MODAL,
    TOGGLE_FEED_FILTER_RATE_MODAL,
    ToggleFeedFilterPriorityModalAction,
    ToggleFeedFilterRateModalAction,
    UPDATE_FEED_FILTER_CELL_RESULT,
    UPDATE_FEED_FILTER_PRIORITY_CELL,
    UPDATE_FEED_FILTER_RATE_CELL,
    UpdateFeedFilterCellResultAction
} from '../../actions/feed-filters/grid';
import {
    BIND_MINUS_PHRASE_TO_GRID_GROUPS,
    CHANGE_COLUMNS_GRID_ORDER,
    CHANGE_COLUMNS_GRID_VISIBILITY,
    CHANGE_COPIED_RETARGETING_RULES_TOOLTIP_STATUS,
    CLOSE_EDIT_POPUP,
    CLOSE_MINUS_PHRASE_SELECTOR_GRID_MODAL,
    DELETE_CELL_EDIT_DATA,
    ERROR_GRID_DATA,
    GET_BANNER_MODERATION_REJECT_REASONS,
    GET_GROUP_MODERATION_REJECT_REASONS,
    GRID_CHANGE_ADJUSTMENT_DATA,
    ON_GRID_SOURCE_PARAMS_CHANGED,
    OPEN_DUPLICATE_GROUPS_MODAL,
    OPEN_EDIT_CAMPAIGN_POPUP,
    OPEN_EDIT_GROUPS_POPUP,
    OPEN_MINUS_PHRASE_SELECTOR_GRID_MODAL,
    REPLACE_GRID_ITEMS,
    REQUEST_GRID_ITEMS_BY_SELECTION,
    RESET_GRID_DATA,
    RESET_GRID_STATE,
    RESET_SUGGEST_DATA,
    REVERT_GRID_ITEMS,
    SCROLL_TABLE_END,
    SCROLL_TABLE_START,
    SELECT_MINUS_PHRASES_IN_GRID_MODAL,
    SelectMinusPhrasesInGridModal,
    SET_BANNER_AIMING_POPUP,
    SET_BANNER_AIMING_POPUP_PENDING,
    SET_BANNER_MODERATION_REJECT_REASONS_ERROR,
    SET_GROUP_MODERATION_REJECT_REASONS_ERROR,
    SHOW_ERROR_MINUS_PHRASE_ITEMS_GRID_IN_MODAL,
    START_BANNER_AIMING,
    SWICH_ONLY_FAVORITE_CAMPAIGNS_FILTER,
    SWITCH_ADJUSTMENT_VISIBILITY,
    SWITCH_GRID_TOTAL_BOX_VISIBLE,
    TOGGLE_COMPACT_VIEW,
    UNBIND_MINUS_PHRASE_TO_GRID_GROUPS,
    UPDATE_ACTION_PROGRESS,
    UPDATE_ADDITIONAL_FILTER,
    UPDATE_BANNER_MODERATION_REJECT_REASONS,
    UPDATE_CALC_TYPE_FILTER,
    UPDATE_CELL_EDIT_DATA,
    UPDATE_COLUMNS_SETTINGS_GRID_STATE,
    UPDATE_COMMON_SETTINGS_GRID_STATE,
    UPDATE_DUPLICATE_GROUPS_ITEMS_DATA,
    UPDATE_GOALS_SETTINGS_GRID_STATE,
    UPDATE_GRID_COLUMNS_WIDTH,
    UPDATE_GRID_DATA,
    UPDATE_GRID_FEATURES,
    UPDATE_GRID_FILTER_DICT,
    UPDATE_GRID_SCREEN_RECOMMENDATION_ITEM,
    UPDATE_GRID_SELECTION,
    UPDATE_GROUP_MODERATION_REJECT_REASONS,
    UPDATE_MINUS_PHRASE_ITEMS_GRID_IN_MODAL,
    UPDATE_SUGGEST_DATA,
    UPDATE_TOOLTIP_DATA
} from '../../actions/grid-screen';
import {
    ACCEPT_DUPLICATE_GROUPS_ITEMS,
    CHANGE_DUPLICATE_GROUPS_MODAL_VIEW_STATE,
    CHANGE_DUPLICATE_GROUPS_RADIO_CONTROL_STATE,
    CLEAR_DUPLICATE_GROUPS_SELECTED_CAMPAIGN,
    CLOSE_DUPLICATE_GROUPS_MODAL,
    FETCH_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS,
    RESET_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_STATE,
    SET_ACCEPT_TO_DUPLICATE_SELECTED_GROUPS,
    SET_DUPLICATE_GROUPS_DRAFT_SELECTED_CAMPAIGN,
    SET_DUPLICATE_GROUPS_SELECTED_CAMPAIGN,
    SHOW_ERROR_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS,
    UPDATE_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS
} from '../../actions/groupsDuplicateSelector';
import {
    CLEAR_REPLACE_PHRASES_ERROR,
    FINISH_SEARCH_AND_REPLACE_LOADING,
    GET_PHRASE_REPLACE_PREVIEW,
    REPLACE_PHRASES,
    RESET_SEARCH_AND_REPLACE_INSPECTOR_STATE,
    SHOW_REPLACE_PHRASES_ERROR,
    SWITCH_SEARCH_AND_REPLACE_INSPECTOR_VISIBILITY,
    UPDATE_PHRASE,
    UPDATE_PHRASE_BID,
    UPDATE_PHRASE_BID_REMOTE,
    UPDATE_PHRASE_REMOTE,
    UPDATE_PHRASES_PREVIEW,
    UPDATE_SEARCH_AND_REPLACE_INSPECTOR_VALUE
} from '../../actions/phrases-grid';
import { UPDATE_RETARGETING, UPDATE_RETARGETING_COMMON_PRICE_CELL } from '../../actions/retargetingCommonPriceEditor';
import { SelectorStatus } from '../../components/CampaignAndGroupSelector/CampaignAndGroupSelector';
import { selectIsFilterChangedFlag } from '../../selectors/grid/grid';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { AdditionalFiltersInStorageHelpers } from '../../service/AdditionalFiltersInStorageHelpers';
import {
    deleteEditCellData,
    prepareGridDataStatsInfo,
    updateEditCellData
} from '../../service/GridHelpers/GridHelpers';
import { isSelectedMoreThenInGrid } from '../../service/gridItemsActionsHelpers/gridItemsActionsHelpers';
import { GridStorageHelper } from '../../service/GridStorageHelper/GridStorageHelper';
import { ReducerCustom } from '../../service/Redux/Redux';
import { banners, campaigns, groups } from '../../typings/common';
import {
    AdditionalFiltersDict,
    Banner,
    BannersAdditionalFilter,
    Campaign,
    CampaignsAdditionalFilter,
    FeedFilter,
    Group,
    GroupsAdditionalFilter,
    Phrase,
    Retargeting,
    ScreenAdditionalFilter
} from '../../typings/domain';
import { GdRecommendationStatus } from '../../typings/graphql-grid';
import {
    getEmptyGridSelectionInfo,
    getEmptySearchAndReplaceInspectorState,
    GridData,
    GridEditedEntityType,
    GridInitialData,
    GridSelection,
    GridSelectionInfo,
    GridSourceParams,
    GridTotalStatsInfo,
    GridViewType
} from '../../typings/grid';
import { DuplicateGroupsModalViewState, DuplicateItem, DuplicateRadioControlType } from '../../typings/groups';
import { RecommendationType } from '../../typings/recommendations';
import { GridState, State } from '../../typings/state';

import { getGridInitialState, resetGridDataReducer, resetGridStateReducer } from './helpers';

function changeAdditionalFilterValueInDict(
    additionalFilterDict: AdditionalFiltersDict,
    view: GridViewType,
    additionalFilter: ScreenAdditionalFilter
): AdditionalFiltersDict {
    const newAdditionalFilterDict = { ...additionalFilterDict };
    switch (additionalFilter) {
        case CampaignsAdditionalFilter.ALL_ARCHIVED:
        case CampaignsAdditionalFilter.ALL_ACTIVE:
        case CampaignsAdditionalFilter.ALL:
            newAdditionalFilterDict[campaigns] = additionalFilter;
            break;
        case GroupsAdditionalFilter.ALL_ARCHIVED:
        case GroupsAdditionalFilter.ALL_ACTIVE:
        case GroupsAdditionalFilter.ALL:
            newAdditionalFilterDict[groups] = additionalFilter;
            break;
        case BannersAdditionalFilter.ALL_ARCHIVED:
        case BannersAdditionalFilter.ALL_ACTIVE:
        case BannersAdditionalFilter.ALL:
            newAdditionalFilterDict[banners] = additionalFilter;
            break;
        default:
            break;
    }
    AdditionalFiltersInStorageHelpers.setFilter(newAdditionalFilterDict);

    return newAdditionalFilterDict;
}

function getNewSelectionInfoForUpdate(
    viewType: GridViewType,
    currentSelectionInfo: GridSelectionInfo,
    selection: GridSelection
): GridSelectionInfo {
    const newSelectionInfoValue = cloneDeep(currentSelectionInfo);

    newSelectionInfoValue[viewType] = selection;

    if (viewType === campaigns) {
        newSelectionInfoValue.groups = [];
    }

    if (viewType === groups || viewType === campaigns) {
        newSelectionInfoValue.banners = [];
        newSelectionInfoValue.phrases = [];
        newSelectionInfoValue.feedFilters = [];
        newSelectionInfoValue.retargetings = [];
        newSelectionInfoValue.usersProfile = [];
    }

    return newSelectionInfoValue;
}

function getNewSelectionInfoForSourceParamsUpdate(
    params: GridSourceParams,
    currentSelectionInfo: GridSelectionInfo
): GridSelectionInfo {
    const { campaignsIds, groupsIds } = params;
    let selectionInfo;

    if (campaignsIds && !isEqual(campaignsIds.sort(), currentSelectionInfo.campaigns.sort())) {
        selectionInfo = {
            campaigns: campaignsIds,
            groups: groupsIds || [],
            banners: [],
            phrases: [],
            retargetings: [],
            feedFilters: [],
            usersProfile: []
        };
    } else if (groupsIds && !isEqual(groupsIds.sort(), currentSelectionInfo.groups.sort())) {
        selectionInfo = {
            campaigns: [...currentSelectionInfo.campaigns],
            groups: groupsIds,
            banners: [],
            phrases: [],
            retargetings: [],
            feedFilters: [],
            usersProfile: []
        };
    } else {
        selectionInfo = cloneDeep(currentSelectionInfo);
    }

    return selectionInfo;
}

function changeGridRecommendationStatus(
    gridData: GridData,
    recommendationType: RecommendationType,
    recommendationStatus: GdRecommendationStatus,
    id: string
): GridData {
    return {
        ...gridData,
        data: gridData.data.map((data: Campaign | Banner | Group) => {
            if (data.id === id && data.recommendations && data.recommendations.data) {
                return {
                    ...data,
                    recommendations: data.recommendations.data.map(recommendationItem => {
                        if (recommendationItem.type === recommendationType) {
                            return {
                                ...recommendationItem,
                                status: recommendationStatus
                            };
                        } else {
                            return recommendationItem;
                        }
                    })
                };
            } else {
                return {
                    ...data
                };
            }
        })
    };
}

function prepareGridData(gridData: GridData, currentStatsInfo: GridTotalStatsInfo | undefined): GridData {
    const newStatsInfo = gridData.totalStats;

    return {
        data: gridData.data,
        allItemsIds: gridData.allItemsIds.slice(),
        total: gridData.total,
        cacheKey: gridData.cacheKey,
        totalStats: prepareGridDataStatsInfo(newStatsInfo, currentStatsInfo)
    };
}
const selectItemInMinusPhraseGridList = (state: GridState, action: SelectMinusPhrasesInGridModal): string[] => {
    const selectedMinusPhrasesListItems = state.minusPhrasesSelectorData.selectedMinusPhrasesIds;

    let newSelectedMinusPhrasesListItems: string[] = [];

    if (selectedMinusPhrasesListItems.includes(action.id)) {
        newSelectedMinusPhrasesListItems = selectedMinusPhrasesListItems.filter(item => item !== action.id);
    } else {
        newSelectedMinusPhrasesListItems = [...selectedMinusPhrasesListItems, action.id];
    }

    return newSelectedMinusPhrasesListItems;
};

function toggleFeedFilterRateModal(state: GridState, action: ToggleFeedFilterRateModalAction): GridState {
    const { feedFilters } = state;

    return {
        ...state,
        feedFilters: {
            ...feedFilters,
            isRateModalOpen: !feedFilters.isRateModalOpen
        }
    };
}

function toggleFeedFilterPriorityModal(state: GridState, action: ToggleFeedFilterPriorityModalAction): GridState {
    const { feedFilters } = state;

    return {
        ...state,
        feedFilters: {
            ...feedFilters,
            isPriorityModalOpen: !feedFilters.isPriorityModalOpen
        }
    };
}

function updateFeedFilterCellResult(state: GridState, action: UpdateFeedFilterCellResultAction): GridState {
    const { gridData } = state;

    return {
        ...state,
        gridData: {
            ...gridData,
            data: gridData.data.map(
                (feedFilter: FeedFilter): FeedFilter => {
                    if (feedFilter.id !== action.feedFilter.id) {
                        return { ...feedFilter };
                    }

                    return {
                        ...feedFilter,
                        ...action.feedFilter
                    };
                }
            )
        }
    };
}

export function getGrid(data: GridInitialData): ReducerCustom<GridState> {
    const gridInitialState: GridState = getGridInitialState(data);

    return function(state: GridState = gridInitialState, action: Action, fullState: State): GridState {
        switch (action.type) {
            case ON_GRID_SOURCE_PARAMS_CHANGED: {
                const { params, query = {} } = action;

                return {
                    ...state,
                    campaignsCalcTypeFilter: params.campaignsCalcTypeFilter,
                    isFilterParamsChanged: selectIsFilterChangedFlag(fullState, query),
                    selectionInfo: getNewSelectionInfoForSourceParamsUpdate(params, state.selectionInfo),
                    inspector: {
                        pricesWizardOpened: false
                    },
                    searchAndReplaceInspectorState: {
                        ...state.searchAndReplaceInspectorState,
                        visible: false
                    }
                };
            }
            case RESET_GRID_DATA:
                return resetGridDataReducer(state);

            case RESET_GRID_STATE: {
                return resetGridStateReducer(state, fullState);
            }

            case UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE:
            case UPDATE_GRID_BANNER_PRICE_CELL:
            case UPDATE_PHRASE_REMOTE:
            case UPDATE_PHRASE_BID_REMOTE:
            case UPDATE_FEED_FILTER_RATE_CELL:
            case UPDATE_RETARGETING_COMMON_PRICE_CELL:
            case UPDATE_FEED_FILTER_PRIORITY_CELL: {
                const { view } = selectGridSourceParams(fullState);

                return {
                    ...state,
                    editCellsData: updateEditCellData(
                        {
                            ...action.cellKeyPartial,
                            view
                        },
                        cloneDeep(state.editCellsData),
                        { isSaving: true }
                    )
                };
            }
            case UPDATE_CELL_EDIT_DATA:
                return {
                    ...state,
                    editCellsData: updateEditCellData(
                        action.cellKeysFields,
                        cloneDeep(state.editCellsData),
                        action.data
                    )
                };
            case SCROLL_TABLE_START:
                return {
                    ...state,
                    isGridScrolling: true
                };
            case SCROLL_TABLE_END:
                return {
                    ...state,
                    isGridScrolling: false
                };
            case DELETE_CELL_EDIT_DATA:
                return {
                    ...state,
                    editCellsData: deleteEditCellData(action.cellKeysFields, cloneDeep(state.editCellsData))
                };
            case UPDATE_GRID_COLUMNS_WIDTH:
                return {
                    ...state,
                    columnsSettings: cloneDeep(action.columns)
                };
            case CHANGE_COLUMNS_GRID_VISIBILITY:
                return {
                    ...state,
                    columnsSettings: cloneDeep(action.columns)
                };
            case CHANGE_COLUMNS_GRID_ORDER:
                return {
                    ...state,
                    columnsSettings: {
                        ...state.columnsSettings,
                        [action.view]: {
                            ...state.columnsSettings[action.view],
                            columnOrder: action.columnOrder
                        }
                    }
                };

            case UPDATE_ACTION_PROGRESS:
                return {
                    ...state,
                    isActionInProgress: action.isActionInProgress
                };

            case UPDATE_GRID_DATA: {
                return {
                    ...state,
                    gridData: prepareGridData(action.gridData, state.gridData.totalStats),
                    goalsSettings: action.goalsSettings,
                    hasObjectsOverLimit: action.hasObjectsOverLimit,
                    clientInfo: action.clientInfo,
                    scrollPosition: action.scrollPosition,
                    gridReqId: action.gridReqId
                };
            }

            case ERROR_GRID_DATA: {
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        error: action.error
                    }
                };
            }

            case UPDATE_GRID_FEATURES: {
                return {
                    ...state,
                    isActionInProgress: false,
                    gridActionFeatures: action.gridActionFeatures
                };
            }

            case UPDATE_SUGGEST_DATA:
                return {
                    ...state,
                    // gridData: {
                    //   ...state.gridData,
                    //   totalStats: undefined
                    // },
                    textSuggestItems: cloneDeep(action.textSuggestItems),
                    isSuggestItemsRequested: true
                };

            case RESET_SUGGEST_DATA:
                return {
                    ...state,
                    textSuggestItems: [],
                    isSuggestItemsRequested: false
                };

            case UPDATE_GRID_SELECTION:
                const sourceParams = selectGridSourceParams(fullState);
                const selectionInfo =
                    sourceParams && sourceParams.view
                        ? getNewSelectionInfoForUpdate(sourceParams.view, state.selectionInfo, action.selection)
                        : getEmptyGridSelectionInfo();

                if (
                    sourceParams &&
                    sourceParams.view === groups &&
                    state.gridActionFeatures === undefined &&
                    isSelectedMoreThenInGrid(selectionInfo.groups, state.gridData.data)
                ) {
                    return {
                        ...state,
                        selectionInfo,
                        isActionInProgress: true
                    };
                }

                return {
                    ...state,
                    selectionInfo,
                    isActionInProgress: false
                };
            case DELETE_BRAND_LIFT_STATUS:
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map((campaign: Campaign) => {
                            if (campaign.id !== action.campaignIds[0]) {
                                return { ...campaign };
                            }

                            return {
                                ...campaign,
                                brandSurveyId: undefined,
                                brandSurveyStatus: undefined
                            };
                        })
                    }
                };
            case UPDATE_GRID_BANNER_PRICE:
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map((banner: Banner) => {
                            if (banner.id !== action.bannerId) {
                                return { ...banner };
                            }
                            return {
                                ...banner,
                                bannerPrice: action.bannerPrice,
                                status: action.status || banner.status
                            };
                        })
                    }
                };
            case OPEN_EDIT_CAMPAIGN_POPUP:
                return {
                    ...state,
                    editedEntity: {
                        type: GridEditedEntityType.Campaign,
                        campaignType: action.campaignType,
                        id: action.campaignId,
                        login: action.login
                    }
                };
            case OPEN_EDIT_GROUPS_POPUP:
                return {
                    ...state,
                    editedEntity: {
                        type: GridEditedEntityType.Group,
                        groupIds: action.groupIds,
                        bannerIds: action.bannerIds,
                        campaignId: action.campaignId,
                        campaignType: action.campaignType,
                        login: action.login,
                        anchor: action.anchor
                    }
                };

            case CLOSE_EDIT_POPUP:
                return {
                    ...state,
                    editedEntity: undefined
                };

            case UPDATE_RETARGETING:
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map(
                            (retargeting: Retargeting): Retargeting => {
                                if (retargeting.id !== action.retargeting.id) {
                                    return { ...retargeting };
                                }

                                return {
                                    ...retargeting,
                                    ...action.retargeting
                                };
                            }
                        )
                    }
                };

            case UPDATE_PHRASE:
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map(
                            (phrase: Phrase): Phrase => {
                                if (phrase.id !== action.phrase.id) {
                                    return phrase;
                                }

                                return {
                                    ...phrase,
                                    ...action.phrase
                                };
                            }
                        )
                    }
                };

            case UPDATE_PHRASE_BID:
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map(
                            (phrase: Phrase): Phrase => {
                                if (phrase.id !== action.phrase.id) {
                                    return phrase;
                                }

                                return {
                                    ...phrase,
                                    price: action.phrase.exactPriceSearch || phrase.price,
                                    priceContext: action.phrase.exactPriceContext || phrase.priceContext,
                                    autobudgetPriority: action.phrase.autobudgetPriority || phrase.autobudgetPriority
                                };
                            }
                        )
                    }
                };

            case UPDATE_TOOLTIP_DATA:
                return {
                    ...state,
                    tooltips: {
                        ...state.tooltips,
                        [action.id]: action.value
                    }
                };

            case GET_PHRASE_REPLACE_PREVIEW:
                return {
                    ...state,
                    searchAndReplaceInspectorState: {
                        ...state.searchAndReplaceInspectorState,
                        isPreviewLoading: true,
                        error: undefined
                    }
                };

            case REPLACE_PHRASES:
                return {
                    ...state,
                    searchAndReplaceInspectorState: {
                        ...state.searchAndReplaceInspectorState,
                        isReplaceLoading: true,
                        error: undefined
                    }
                };

            case UPDATE_PHRASES_PREVIEW:
                return {
                    ...state,
                    searchAndReplaceInspectorState: {
                        ...state.searchAndReplaceInspectorState,
                        preview: action.preview
                    }
                };

            case SWITCH_SEARCH_AND_REPLACE_INSPECTOR_VISIBILITY:
                return {
                    ...state,
                    searchAndReplaceInspectorState: {
                        ...state.searchAndReplaceInspectorState,
                        visible: action.visible
                    }
                };

            case SHOW_REPLACE_PHRASES_ERROR:
                return {
                    ...state,
                    searchAndReplaceInspectorState: {
                        ...state.searchAndReplaceInspectorState,
                        error: action.error
                    }
                };

            case CLEAR_REPLACE_PHRASES_ERROR:
                return {
                    ...state,
                    searchAndReplaceInspectorState: {
                        ...state.searchAndReplaceInspectorState,
                        error: undefined
                    }
                };

            case FINISH_SEARCH_AND_REPLACE_LOADING:
                return {
                    ...state,
                    searchAndReplaceInspectorState: {
                        ...state.searchAndReplaceInspectorState,
                        isReplaceLoading: false,
                        isPreviewLoading: false
                    }
                };

            case RESET_SEARCH_AND_REPLACE_INSPECTOR_STATE:
                return {
                    ...state,
                    searchAndReplaceInspectorState: getEmptySearchAndReplaceInspectorState()
                };

            case UPDATE_SEARCH_AND_REPLACE_INSPECTOR_VALUE:
                const { searchAndReplaceInspectorState } = state;

                return {
                    ...state,
                    searchAndReplaceInspectorState: {
                        ...searchAndReplaceInspectorState,
                        value: {
                            ...searchAndReplaceInspectorState.value,
                            ...action.value
                        },
                        error: undefined
                    }
                };

            case UPDATE_ADDITIONAL_FILTER: {
                const { view } = selectGridSourceParams(fullState);

                return {
                    ...state,
                    additionalFilterDict: changeAdditionalFilterValueInDict(
                        state.additionalFilterDict,
                        action.view,
                        action.additionalFilter
                    ),
                    selectionInfo: view
                        ? getNewSelectionInfoForUpdate(view, state.selectionInfo, [] as GridSelection)
                        : getEmptyGridSelectionInfo(),
                    gridData: {
                        ...state.gridData,
                        totalStats: undefined
                    }
                };
            }

            case UPDATE_CALC_TYPE_FILTER: {
                const { view } = selectGridSourceParams(fullState);

                return {
                    ...state,
                    campaignsCalcTypeFilter: action.calcTypeFilter,
                    selectionInfo: view
                        ? getNewSelectionInfoForUpdate(view, state.selectionInfo, [] as GridSelection)
                        : getEmptyGridSelectionInfo(),
                    gridData: {
                        ...state.gridData,
                        totalStats: undefined
                    },
                    textSuggestItems: []
                };
            }

            case UPDATE_GRID_SCREEN_RECOMMENDATION_ITEM:
                return {
                    ...state,
                    gridData: changeGridRecommendationStatus(
                        state.gridData,
                        action.recommendationType,
                        action.status,
                        action.id
                    )
                };

            case SWITCH_GRID_TOTAL_BOX_VISIBLE: {
                return {
                    ...state,
                    isGridTotalBoxVisible: GridStorageHelper.setGridTotalBoxVisibility(!state.isGridTotalBoxVisible)
                };
            }

            case SWICH_ONLY_FAVORITE_CAMPAIGNS_FILTER: {
                return {
                    ...state,
                    isOnlyFavoriteCampaignsVisible: GridStorageHelper.setOnlyFavoriteCampaignsSetting(
                        !state.isOnlyFavoriteCampaignsVisible
                    )
                };
            }

            case TOGGLE_COMPACT_VIEW: {
                return {
                    ...state,
                    isCompactViewEnabled: GridStorageHelper.setCompactViewEnabled(!state.isCompactViewEnabled)
                };
            }

            case UPDATE_GRID_FILTER_DICT: {
                return {
                    ...state,
                    filterDict: action.filterDict
                };
            }

            case OPEN_CAMPAIGN_AND_GROUP_SELECTOR: {
                return {
                    ...state,
                    campaignAndGroupSelector: {
                        ...state.campaignAndGroupSelector,
                        isCampaignAndGroupSelectorOpen: true,
                        entityToSelectType: action.entityToSelectType
                    }
                };
            }

            case SET_CAMPAIGN_AND_GROUP_SELECTOR_ENTITY_TYPE: {
                return {
                    ...state,
                    campaignAndGroupSelector: {
                        entityToSelectType: action.entityToSelectType,
                        isCampaignAndGroupSelectorOpen: false,
                        selectorStatus: SelectorStatus.READY
                    }
                };
            }

            case CLOSE_CAMPAIGN_AND_GROUP_SELECTOR: {
                return {
                    ...state,
                    campaignAndGroupSelector: {
                        ...state.campaignAndGroupSelector,
                        isCampaignAndGroupSelectorOpen: false,
                        campaignSelected: undefined,
                        campaignItems: undefined,
                        groupSelected: undefined,
                        groupItems: undefined,
                        entityToSelectType: undefined
                    }
                };
            }

            case UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA: {
                return {
                    ...state,
                    campaignAndGroupSelector: {
                        ...state.campaignAndGroupSelector,
                        campaignItems: action.campaignItems
                    }
                };
            }

            case SELECT_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGN: {
                return {
                    ...state,
                    campaignAndGroupSelector: {
                        ...state.campaignAndGroupSelector,
                        campaignSelected: action.campaignSelected
                    }
                };
            }

            case CHANGE_CAMPAIGN_AND_GROUP_SELECTOR_STATUS: {
                return {
                    ...state,
                    campaignAndGroupSelector: {
                        ...state.campaignAndGroupSelector,
                        selectorStatus: action.selectorStatus
                    }
                };
            }

            case UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA: {
                return {
                    ...state,
                    campaignAndGroupSelector: {
                        ...state.campaignAndGroupSelector,
                        groupItems: action.groupItems
                    }
                };
            }

            case SELECT_CAMPAIGN_AND_GROUP_SELECTOR_GROUP: {
                return {
                    ...state,
                    campaignAndGroupSelector: {
                        ...state.campaignAndGroupSelector,
                        groupSelected: action.groupSelected
                    }
                };
            }

            case GET_BANNER_MODERATION_REJECT_REASONS: {
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map((banner: Banner) => {
                            if (banner.id !== action.bid) {
                                return banner;
                            }

                            return {
                                ...banner,
                                rejectReasons: undefined
                            };
                        })
                    }
                };
            }

            case UPDATE_BANNER_MODERATION_REJECT_REASONS: {
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map((banner: Banner) => {
                            if (banner.id !== action.bid) {
                                return banner;
                            }

                            return {
                                ...banner,
                                rejectReasons: action.reasons
                            };
                        })
                    }
                };
            }

            case SET_BANNER_MODERATION_REJECT_REASONS_ERROR: {
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map((banner: Banner) => {
                            if (banner.id !== action.bid) {
                                return banner;
                            }

                            return {
                                ...banner,
                                rejectReasons: {
                                    items: [],
                                    error: action.error
                                }
                            };
                        })
                    }
                };
            }

            case GET_GROUP_MODERATION_REJECT_REASONS: {
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map((group: Group) => {
                            if (group.id !== action.groupId) {
                                return group;
                            }
                            return {
                                ...group,
                                rejectReasons: undefined
                            };
                        })
                    }
                };
            }

            case SET_BRAND_LIFT_REJECT_REASONS: {
                return {
                    ...state,
                    brandLiftRejectReason: {
                        ...state.brandLiftRejectReason,
                        [action.surveyId]: action.reasons
                    }
                };
            }

            case UPDATE_GROUP_MODERATION_REJECT_REASONS: {
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map((group: Group) => {
                            if (group.id !== action.groupId) {
                                return group;
                            }

                            return {
                                ...group,
                                rejectReasons: action.reasons
                            };
                        })
                    }
                };
            }

            case SET_GROUP_MODERATION_REJECT_REASONS_ERROR: {
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map((group: Group) => {
                            if (group.id !== action.groupId) {
                                return group;
                            }

                            return {
                                ...group,
                                rejectReasons: {
                                    items: [],
                                    error: action.error
                                }
                            };
                        })
                    }
                };
            }

            case START_BANNER_AIMING: {
                if (!state.bannerAimingPopup) {
                    return state;
                }
                return {
                    ...state,
                    bannerAimingPopup: {
                        ...state.bannerAimingPopup,
                        pending: true
                    }
                };
            }

            case SET_BANNER_AIMING_POPUP: {
                return {
                    ...state,
                    bannerAimingPopup: action.payload
                };
            }

            case SET_BANNER_AIMING_POPUP_PENDING: {
                if (!state.bannerAimingPopup) {
                    return state;
                }
                return {
                    ...state,
                    bannerAimingPopup: {
                        ...state.bannerAimingPopup,
                        pending: action.payload
                    }
                };
            }

            case GRID_CHANGE_ADJUSTMENT_DATA: {
                return {
                    ...state,
                    phraseAdjustment: {
                        ...state.phraseAdjustment,
                        ...action.data
                    }
                };
            }

            case SWITCH_ADJUSTMENT_VISIBILITY: {
                const { phraseAdjustment } = state;

                return {
                    ...state,
                    phraseAdjustment: {
                        ...phraseAdjustment,
                        visible: action.visible,
                        showsForecast: action.visible ? phraseAdjustment.showsForecast : undefined,
                        items: undefined
                    }
                };
            }

            case OPEN_MINUS_PHRASE_SELECTOR_GRID_MODAL: {
                return {
                    ...state,
                    minusPhrasesSelectorData: {
                        ...state.minusPhrasesSelectorData,
                        groupsIds: action.groupsIds,
                        isMinusPhraseSelectorModalOpened: true
                    }
                };
            }

            case CLOSE_MINUS_PHRASE_SELECTOR_GRID_MODAL: {
                return {
                    ...state,
                    minusPhrasesSelectorData: {
                        ...state.minusPhrasesSelectorData,
                        groupsIds: [],
                        isMinusPhraseSelectorModalOpened: false,
                        selectedMinusPhrasesIds: [],
                        isLoading: false,
                        apiError: false,
                        items: undefined
                    }
                };
            }

            case SELECT_MINUS_PHRASES_IN_GRID_MODAL: {
                return {
                    ...state,
                    minusPhrasesSelectorData: {
                        ...state.minusPhrasesSelectorData,
                        selectedMinusPhrasesIds: selectItemInMinusPhraseGridList(state, action)
                    }
                };
            }

            case UPDATE_MINUS_PHRASE_ITEMS_GRID_IN_MODAL: {
                return {
                    ...state,
                    minusPhrasesSelectorData: {
                        ...state.minusPhrasesSelectorData,
                        items: action.items
                    }
                };
            }

            case SHOW_ERROR_MINUS_PHRASE_ITEMS_GRID_IN_MODAL: {
                return {
                    ...state,
                    minusPhrasesSelectorData: {
                        ...state.minusPhrasesSelectorData,
                        apiError: true,
                        isLoading: false
                    }
                };
            }

            case BIND_MINUS_PHRASE_TO_GRID_GROUPS:
            case UNBIND_MINUS_PHRASE_TO_GRID_GROUPS:
                return {
                    ...state,
                    minusPhrasesSelectorData: {
                        ...state.minusPhrasesSelectorData,
                        isLoading: true
                    }
                };

            case UPDATE_COLUMNS_SETTINGS_GRID_STATE: {
                return {
                    ...state,
                    columnsSettings: cloneDeep(action.columnsSettings)
                };
            }

            case UPDATE_COMMON_SETTINGS_GRID_STATE: {
                return {
                    ...state,
                    ...action.commonSettingsDiff
                };
            }

            case UPDATE_GOALS_SETTINGS_GRID_STATE: {
                return {
                    ...state,
                    goalsSettings: action.goalsSettings
                };
            }

            case OPEN_DUPLICATE_GROUPS_MODAL: {
                return {
                    ...state,
                    isActionInProgress: true
                };
            }

            case UPDATE_DUPLICATE_GROUPS_ITEMS_DATA: {
                return {
                    ...state,
                    duplicateGroupsData: {
                        ...state.duplicateGroupsData,
                        items: action.items,
                        isModalOpen: action.isModalOpen
                    },
                    isActionInProgress: false
                };
            }

            case CLOSE_DUPLICATE_GROUPS_MODAL: {
                return {
                    ...state,
                    duplicateGroupsData: {
                        items: [],
                        selectedRadioButtonType: DuplicateRadioControlType.ACTUAL_CAMPAIGN,
                        isModalOpen: false,
                        isCopyLoading: false,
                        modalViewState: DuplicateGroupsModalViewState.duplicate,
                        campaignsSelector: {
                            error: false,
                            isLoading: false
                        },
                        validationResults: {
                            copyErrorsBrokenGroupsIdxList: [],
                            copyErrorLimitIdxList: [],
                            contentPromotionErrors: {}
                        }
                    }
                };
            }

            case CHANGE_DUPLICATE_GROUPS_RADIO_CONTROL_STATE: {
                return {
                    ...state,
                    duplicateGroupsData: {
                        ...state.duplicateGroupsData,
                        selectedRadioButtonType: action.radioButtonNewState,
                        items: state.duplicateGroupsData.items.map((item: DuplicateItem) => ({
                            ...item,
                            isDisabled: false,
                            isInvalid: false
                        })),
                        validationResults: {
                            copyErrorsBrokenGroupsIdxList: [],
                            copyErrorLimitIdxList: [],
                            contentPromotionErrors: {}
                        }
                    }
                };
            }

            case CHANGE_DUPLICATE_GROUPS_MODAL_VIEW_STATE: {
                return {
                    ...state,
                    duplicateGroupsData: {
                        ...state.duplicateGroupsData,
                        modalViewState: action.modalViewState
                    }
                };
            }

            case CLEAR_DUPLICATE_GROUPS_SELECTED_CAMPAIGN: {
                return {
                    ...state,
                    duplicateGroupsData: {
                        ...state.duplicateGroupsData,
                        selectedCampaign: undefined
                    }
                };
            }

            case SET_DUPLICATE_GROUPS_SELECTED_CAMPAIGN:
                return {
                    ...state,
                    duplicateGroupsData: {
                        ...state.duplicateGroupsData,
                        selectedCampaign: state.duplicateGroupsData.campaignsSelector.draftCampaignSelected,
                        modalViewState: DuplicateGroupsModalViewState.duplicate
                    }
                };

            case SET_DUPLICATE_GROUPS_DRAFT_SELECTED_CAMPAIGN:
                return {
                    ...state,
                    duplicateGroupsData: {
                        ...state.duplicateGroupsData,
                        campaignsSelector: {
                            ...state.duplicateGroupsData.campaignsSelector,
                            draftCampaignSelected: action.draftCampaignSelected
                        }
                    }
                };

            case RESET_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_STATE:
                return {
                    ...state,
                    duplicateGroupsData: {
                        ...state.duplicateGroupsData,
                        campaignsSelector: {
                            ...state.duplicateGroupsData.campaignsSelector,
                            draftCampaignSelected: undefined,
                            campaignItems: [],
                            error: false
                        }
                    }
                };

            case UPDATE_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS:
                return {
                    ...state,
                    duplicateGroupsData: {
                        ...state.duplicateGroupsData,
                        campaignsSelector: {
                            ...state.duplicateGroupsData.campaignsSelector,
                            campaignItems: action.items,
                            isLoading: false
                        }
                    }
                };

            case SHOW_ERROR_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS:
                return {
                    ...state,
                    duplicateGroupsData: {
                        ...state.duplicateGroupsData,
                        campaignsSelector: {
                            ...state.duplicateGroupsData.campaignsSelector,
                            error: true,
                            isLoading: false
                        }
                    }
                };

            case FETCH_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS:
                return {
                    ...state,
                    duplicateGroupsData: {
                        ...state.duplicateGroupsData,
                        campaignsSelector: {
                            ...state.duplicateGroupsData.campaignsSelector,
                            textInput: action.textInput,
                            isLoading: true
                        }
                    }
                };

            case ACCEPT_DUPLICATE_GROUPS_ITEMS:
                return {
                    ...state,
                    duplicateGroupsData: {
                        ...state.duplicateGroupsData,
                        isCopyLoading: true
                    }
                };

            case SET_ACCEPT_TO_DUPLICATE_SELECTED_GROUPS:
                return {
                    ...state,
                    duplicateGroupsData: {
                        ...state.duplicateGroupsData,
                        validationResults: {
                            copyErrorLimitIdxList: action.copyErrorLimitIdxList,
                            copyErrorsBrokenGroupsIdxList: action.copyErrorsBrokenGroupsIdxList,
                            contentPromotionErrors: action.contentPromotionErrors
                        },
                        isCopyLoading: false
                    }
                };
            case TOGGLE_FEED_FILTER_RATE_MODAL:
                return toggleFeedFilterRateModal(state, action);
            case TOGGLE_FEED_FILTER_PRIORITY_MODAL:
                return toggleFeedFilterPriorityModal(state, action);
            case UPDATE_FEED_FILTER_CELL_RESULT:
                return updateFeedFilterCellResult(state, action);

            case CHANGE_COPIED_RETARGETING_RULES_TOOLTIP_STATUS:
                return {
                    ...state,
                    retargetingRulesInfo: {
                        copyTooltipStatus: action.newStatus
                    }
                };

            case REQUEST_GRID_ITEMS_BY_SELECTION: {
                const selectedItems = new Set(action.selectionInfo[action.view]);

                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map(item =>
                            selectedItems.has(item.id) ? { ...item, isLoading: true } : item
                        )
                    }
                };
            }

            case REPLACE_GRID_ITEMS: {
                const { payload } = action;

                const newItems = payload.data.reduce((acc, item) => {
                    acc[item.id] = item;
                    return acc;
                }, {});

                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map(item => {
                            if (item.id in newItems) {
                                return newItems[item.id];
                            } else if (item.isLoading) {
                                return {
                                    ...item,
                                    isLoading: false
                                };
                            }
                            return item;
                        })
                    }
                };
            }

            case REVERT_GRID_ITEMS: {
                return {
                    ...state,
                    gridData: {
                        ...state.gridData,
                        data: state.gridData.data.map(item => (item.isLoading ? { ...item, isLoading: false } : item))
                    }
                };
            }

            default:
                return state;
        }
    };
}
